import React from "react";
import QuickLinks from "../menu-items/QuickLinks";
import { IItems } from "../../@types/types";
import SearchInput from "../common/SearchInput";

interface SideBarInnerProps {
  selectedItem: IItems;
  inputValue: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const SideBarInner: React.FC<SideBarInnerProps> = ({
  selectedItem,
  onChange,
  inputValue,
}) => {
  return (
    <div className='side-bar-inner'>
      {selectedItem.menu?.search && (
        <SearchInput
          search={selectedItem.menu?.search}
          inputValue={inputValue}
          onChange={onChange}
        />
      )}
      <QuickLinks
        quickLinks={selectedItem.menu?.quickLinks || []}
        isSearch={selectedItem.menu?.search ? true : false}
      />
    </div>
  );
};

export default SideBarInner;
